import { post } from '../../shared/utils/fetch.util'

export const logEvents = (body, headers) =>
  post('/v2/aAlias/events', body, headers)
